import ScrollableScreen from '@/components/ui/ScrollableScreen'
import RetailerEstimateCreate from '@/components/retailers/estimate/RetailerEstimateCreate'

export default function RetailerEstimates() {
    const breadcrumbs = [
        { label: 'Devis', href: '/retailer_estimates' },
        { label: 'Créer un devis' },
    ]

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs}>
            <RetailerEstimateCreate />
        </ScrollableScreen>
    )
}
